<ui-modal
  class="spot-ladder-modal"
  [isOpened]="isModalOpened"
  modalTitle="Spot Ladder"
  size="lg"
  (isOpenedChange)="modalChanged($event)"
>
  <form
    [hidden]="stepNumber !== 1"
    [formGroup]="form"
    (ngSubmit)="onSubmitStep1()"
    autocomplete="off"
  >
    <div class="spot-ladder-modal__row-spread main-margin">
      <label>
        Currency Pair
        <app-selector
          class="currency-pair"
          formControlName="cross"
          [passedItems]="formControls['cross'].attributes.options"
        ></app-selector>
      </label>
      <label>
        Min Spot
        <input clrInput type="number" formControlName="minSpot" />
      </label>
      <label>
        Max Spot
        <input clrInput type="number" formControlName="maxSpot" />
      </label>
      <label>
        Number of Points
        <input clrInput type="number" formControlName="numberOfPoints" />
      </label>
    </div>
    <div
      class="
        spot-ladder-modal__row-left spot-ladder-modal__row-left--date
        main-margin
      "
    >
      <div class="flex-column">
        <label> Future Dates </label>
        <div class="flex-row">
          <!-- <div formArrayName="fixingsFormArray"
                    *ngFor="let scheduleFixing of fixingsFormArray.controls; let i=index">
                    <clr-date-container>
                        <input
                        [inputValidator]="'dateShorthand'"
                        [type]="'date'"
                        clrDate
                        [formControl]="fixingsFormArray.controls[i]"
                    />
                    </clr-date-container>

                </div>
                <button class="icon-button" (click)="onAddFixingDate()" type="button" style="align-self: flex-end;">
                    <img src="assets/plus-big.svg" />
                </button> -->
          <div class="flex-row__date-container">
            <date-with-spinner-info
              formControlName="fixing1"
              [id]="'fixing1'"
              [info]="fixingsInfo?.fixing1?.info"
            ></date-with-spinner-info>
          </div>
          <div class="flex-row__date-container">
            <date-with-spinner-info
              formControlName="fixing2"
              [id]="'fixing2'"
              [info]="fixingsInfo?.fixing2?.info"
            ></date-with-spinner-info>
          </div>
          <div class="flex-row__date-container">
            <date-with-spinner-info
              formControlName="fixing3"
              [id]="'fixing3'"
              [info]="fixingsInfo?.fixing3?.info"
            ></date-with-spinner-info>
          </div>
        </div>
      </div>
    </div>
    <div class="spot-ladder-modal__row-spread main-margin">
      <div class="flex-column" *ngIf="currencies?.length">
        <label for="reporting">Reporting Currency </label>
        <div class="btn-group btn-sm">
          <div
            id="reporting"
            class="radio btn"
            *ngFor="let currency of currencies; let i = index"
          >
            <input
              type="radio"
              [value]="currency"
              name="stage1CurrencyRadio"
              formControlName="stage1CurrencyRadio"
              id="btn-stage1CurrencyRadio-{{ i }}"
            />
            <label for="btn-stage1CurrencyRadio-{{ i }}">{{ currency }}</label>
          </div>
        </div>
      </div>
      <label
        >Bump Method
        <app-selector
          class="bump-method"
          formControlName="bumpMethod"
          [passedItems]="formControls.bumpMethod.items"
          [id]="formControls.bumpMethod.key"
        ></app-selector>
      </label>
      <div>
        <clr-toggle-container>
          <clr-toggle-wrapper>
            <input
              type="checkbox"
              clrToggle
              value="option1"
              formControlName="intermediaryFlowsToggle"
            />
            <label>Include Intermediary Flows</label>
          </clr-toggle-wrapper>
        </clr-toggle-container>
        <clr-toggle-container>
          <clr-toggle-wrapper>
            <input
              type="checkbox"
              clrToggle
              value="option1"
              formControlName="flowsBeforeDateToggle"
            />
            <label>Include Flows Before Value Date</label>
          </clr-toggle-wrapper>
        </clr-toggle-container>
      </div>
    </div>
    <hr class="hard-return mid-page" />
    <div class="flex-column lesser-margin">
      <label>Calculation Set</label>
      <div class="flex-row">
        <div>
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input
                type="checkbox"
                clrToggle
                formControlName="markToMarketToggle"
              />
              <label>Mark to Market</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input
                type="checkbox"
                clrToggle
                formControlName="spotDeltaToggle"
              />
              <label>Spot Delta</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
        </div>
        <div>
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input type="checkbox" clrToggle formControlName="vegaToggle" />
              <label>Vega</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input type="checkbox" clrToggle formControlName="gammaToggle" />
              <label>Gamma</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
        </div>
        <div>
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input
                type="checkbox"
                clrToggle
                formControlName="cashFlowsToggle"
              />
              <label>Cash Flows</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
        </div>
      </div>
    </div>

    <hr class="hard-return" />

    <div class="modal-footer">
      <button type="button" class="ui-button" (click)="cancel()">Cancel</button>
      <button
        type="button"
        type="submit"
        [disabled]="
          !form?.valid ||
          calculatingStatus.status === 'calculating' ||
          calculatingStatus.status === 'webSocketDown'
        "
        class="ui-button primary modal-footer__calculate-button"
      >
        <div
          class="modal-footer__calculate-button__spinner-container"
          *ngIf="
            calculatingStatus.status === 'calculating';
            else allowCalculating
          "
        >
          <span class="spinner spinner-sm spinner-inverse"> </span>
        </div>
        <ng-template #allowCalculating> Calculate </ng-template>
      </button>
    </div>
  </form>

  <form *ngIf="stepNumber === 2" [formGroup]="step2Form" autocomplete="off">
    <div class="spot-ladder-modal__row-left main-margin">
      <label class="output-data"
        >Output Data
        <app-selector
          formControlName="outputData"
          [passedItems]="formControls.outputData.items"
          [id]="formControls.outputData.key"
        ></app-selector>
      </label>
      <div class="flex-column left-margin" *ngIf="currencies?.length">
        <label for="reporting2">Reporting Currency </label>
        <div class="btn-group btn-sm">
          <div
            id="reporting2"
            class="radio btn"
            *ngFor="let currency of currencies; let i = index"
          >
            <input
              type="radio"
              (change)="reportingCurrencyChanged(i)"
              [value]="currency"
              name="stage2CurrencyRadio"
              formControlName="stage2CurrencyRadio"
              id="btn-stage2CurrencyRadio-{{ i }}"
            />
            <label for="btn-stage2CurrencyRadio-{{ i }}">{{ currency }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="spot-ladder-modal__column-left main-margin">
      <label>Legs</label>
      <div class="spot-ladder-modal__row-left">
        <div
          formArrayName="legsFormArray"
          *ngFor="let leg of legComponents; let i = index"
        >
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input
                type="checkbox"
                (change)="legToggleChange('leg' + (i + 1), $event)"
                clrToggle
                [formControl]="legsFormArrayControls[i]"
              />
              <label>Leg {{ i + 1 }}</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
        </div>
      </div>
    </div>

    <div class="spot-ladder-modal__column-left main-margin">
      <label>Dates </label>
      <div class="spot-ladder-modal__row-left">
        <div
          formArrayName="datesFormArray"
          *ngFor="let date of dateItems; let i = index"
        >
          <clr-toggle-container>
            <clr-toggle-wrapper>
              <input
                type="checkbox"
                (change)="dateToggleChange(date, $event)"
                clrToggle
                [formControl]="datesFormArrayControls[i]"
              />
              <label>{{ date | prettyDate }}</label>
            </clr-toggle-wrapper>
          </clr-toggle-container>
        </div>
      </div>
    </div>
    <hr class="hard-return" />
    <app-spot-ladder-graph
      [spotLadderResults]="spotLadderResults"
      [reportingCurrency]="reportingCurrency"
      [outputData]="currentOutPutData"
      [availableDates]="dateItems"
      [dates]="graphDisplayDates"
      [legs]="graphDisplayLegs"
    ></app-spot-ladder-graph>
    <hr class="hard-return" />

    <div class="modal-footer">
      <button
        type="button"
        class="ui-button primary"
        (click)="onCopyToClipboardClicked()"
      >
        Copy to Clipboard
      </button>
      <button type="button" class="ui-button" (click)="backToSetup()">
        Back to Setup
      </button>

      <button type="button" class="ui-button" (click)="cancel()">Cancel</button>
    </div>
  </form>
</ui-modal>
